import { ApiError } from "../Combined";
import ResultValue from "../Simple/ResultValue";

export default function DRGResults(props) {
    if (props.result && props.result['MSDRG.Error']) {
        return (
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header">
                            DRG Result {(props.serviceMode && (`- ${props.serviceMode}`)) || null}
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6">
                                    <ApiError error={props.result['MSDRG.Error']} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (props.result && props.result['MSDRG.DRGResult']) {
        return (<div className="row">
            <div className="col">
                <div className="card">
                    <div className="card-header">
                        DRG Result {(props.serviceMode && (`- ${props.serviceMode}`)) || null}
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-6">
                                <ResultValue label="DRG Code"
                                    valueClassName="col-8"
                                    labelClassName="align-self-start"
                                    value={props.result['MSDRG.DRGResult']?.drg} />
                                <ResultValue label="DRG Code Description"
                                    valueClassName="col-8"
                                    labelClassName="align-self-start"
                                    value={props.result['MSDRG.DRGResult']?.description} />
                                <ResultValue label="DRG Grouper Version"
                                    valueClassName="col-8"
                                    labelClassName="align-self-start"
                                    value={props.result['MSDRG.DRGResult']?.grouperVersion } />
                                {props.result['MSDRG.OriginalDRG'] && <ResultValue label="Original DRG Code"
                                    valueClassName="col-8"
                                    labelClassName="align-self-start"
                                    value={props.result['MSDRG.OriginalDRG']} />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }

    return null;
}